import { FC, ReactNode } from 'react';
import { BoxProps } from '@chakra-ui/react';
import { Tr } from '@chakra-ui/react';
import { CbTableCellElement } from '../CbTable/CbTableCellElement';
import { CbTableCellText } from '../CbTable/CbTableCellText';
import { TableColumn } from '../../types/TableColumn';
export interface CbGenericTableRowProps extends BoxProps {
  columns: TableColumn[];
  isOddRow: number;
  alternateRowColor: string;
  indexKey: number;
  borderColor: string;
  row: any[];
  paddingX: string;
  textColor: string;
  isHighlighted?: boolean;
  isCustomRow?: boolean;
  customRowComponent?: ReactNode | HTMLDivElement;
}
export const CbGenericTableRow: FC<CbGenericTableRowProps> = ({
  columns,
  isOddRow,
  alternateRowColor,
  borderColor,
  row,
  paddingX,
  textColor,
  isHighlighted,
  isCustomRow,
  customRowComponent
}) => {
  let bg = 'transparent';
  if (isHighlighted) {
    bg = 'rgba(83, 189, 170, 0.4)';
  } else if (isCustomRow) {
    bg = 'transparent';
  } else if (isOddRow) {
    bg = alternateRowColor;
  }
  return <>
      {isCustomRow ? customRowComponent : <Tr backgroundColor={bg} key={Math.random()} width="100%">
          {columns?.map((column, index) => {
        const borderRightColor = index !== columns.length - 1 ? borderColor : '';
        return column.hasCustomCellElement ? <CbTableCellElement key={Math.random()} borderColor={borderRightColor} element={row?.[column?.key]} paddingX={{
          base: 2,
          lg: paddingX
        }} paddingY={{
          base: 2,
          lg: 3
        }} isBold={column.isBold} isCentered={column.isCentered} /> : <CbTableCellText key={Math.random()} borderColor={borderRightColor} text={row?.[column?.key]} textColor={textColor} isBold={column.isBold} isCentered={column.isCentered} leftAdornment={row && column.leftAdornment} hasLeftAdornment={column.leftAdornmentConditionalKey ? row?.[column.leftAdornmentConditionalKey.key] === column.leftAdornmentConditionalKey.showIfValue : true} rightAdornment={column?.rightAdornment} hasRightAdornment={column.rightAdornmentConditionalKey ? row?.[column.rightAdornmentConditionalKey.key] === column.rightAdornmentConditionalKey.showIfValue : true} sideText={column.sideTextKey && row?.[column.sideTextKey]} type={column.type} isTruncated paddingX={{
          base: 2,
          lg: paddingX
        }} paddingY={{
          base: 2,
          lg: 3
        }} />;
      })}
        </Tr>}
    </>;
};